(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ft-home-offers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ft-offer-rail')) {
    customElements.define('ft-offer-rail', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const track = this.querySelector('.ft-offers__track');
        const controls = this.querySelector('.ft-offers__controls');
        if (!track || !controls) return;
        controls.hidden = false;
        const options = { signal: this.abort.signal };
        const move = (direction) => {
          const card = track.querySelector('.ft-offers__card');
          const step = (card?.getBoundingClientRect().width || track.clientWidth) + parseFloat(getComputedStyle(track).columnGap || '0');
          track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-direction]');
          if (button) move(Number(button.dataset.direction));
        }, options);
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
